import { TextStyle } from 'pixi.js';

export const createBubbleTextStyle = (contentWidth: number) => {
  const textSize = Math.floor(contentWidth > 600 ? 30 : contentWidth * 0.07);
  return new TextStyle({
    align: 'left',
    fontFamily: 'sans-serif',
    fontSize: textSize,
    fontWeight: 'bold',
    fill: ['#1f1f1f', '#474747'],
    stroke: '#eef1f5',
    strokeThickness: 1,
    letterSpacing: 2,
    wordWrap: true,
    wordWrapWidth: contentWidth,
  });
};

export const createAnswersTextStyle = (contentWidth: number, answersWidth: number) => {
  const textSize = Math.floor(contentWidth > 600 ? 30 : contentWidth * 0.07);
  return new TextStyle({
    align: 'left',
    fontFamily: 'sans-serif',
    fontSize: textSize,
    fontWeight: 'lighter',
    fill: ['#ffffff', '#f7f7f7'],
    stroke: '#f7f7f7',
    strokeThickness: 1,
    letterSpacing: 2,
    wordWrap: true,
    wordWrapWidth: answersWidth,
  });
};
